import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { handleDeletePerClose } from "../../redux/Reducer/ModalSlice";

const DeleteModal = ({ children, ModalWidth, ModalTitle }) => {
  const dispatch = useDispatch();
  const deletePer = useSelector((state) => state.Modal.openDeletePerModal);
  return (
    <Dialog
      open={deletePer}
      fullWidth={true}
      maxWidth={ModalWidth}
    >
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
        <span
          style={{
            color: "#4187e8",
          }}
        >
          {ModalTitle}
        </span>
        <CloseIcon
          sx={{ mt: "5px", cursor: "pointer" }}
          onClick={() => {
            dispatch(handleDeletePerClose());
          }}
        />
      </DialogTitle>
      <DialogContent dividers style={{ padding: " 0px" }}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default DeleteModal;
